import { all, call, takeLeading } from 'redux-saga/effects';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import { initializeActions } from '../operation/initializeActions';
import { initializeAggregatedActivities } from '../operation/initializeAggregatedActivities';
import { initializeCalculatedInternals } from '../operation/initializeCalculatedInternals';
import { initializeImprovementAreas } from '../operation/initializeImprovementAreas';
import { initializePredictions } from '../operation/initializePredictions';
import { initializeSuggestions } from '../operation/initializeSuggestions';
import { initializeTenant } from '../operation/initializeTenant';
import * as appActions from './actions';
import * as constants from './constants';

function* startInitializeSaga(
  action: ActionType<typeof appActions.startInitialize>,
) {
  function* saga() {
    // All operations run in parallel. Each operation selects its own tenantId
    // and checks its required feature — those that don't qualify return early.
    yield all([
      call(initializeTenant),
      call(initializeAggregatedActivities),
      call(initializeCalculatedInternals),
      call(initializePredictions),
      call(initializeImprovementAreas),
      call(initializeSuggestions),
      call(initializeActions),
    ]);
  }
  yield call(sagaWrapper, { saga, type: action.type });
}

export function* watcher() {
  yield all([takeLeading(constants.START_INITIALIZE, startInitializeSaga)]);
}
